import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'

export const TRANSFORMER = transformers.combine(
  graphql.transformers.OUT.enumeration<
    graphql.schema.ProcessExecutionStatus,
    ents.core.relay.processes.Execution.Status
  >({
    [graphql.schema.ProcessExecutionStatus.Failed]:
      ents.core.relay.processes.Execution.Status.Failed,
    [graphql.schema.ProcessExecutionStatus.InProgress]:
      ents.core.relay.processes.Execution.Status.InProgress,
    [graphql.schema.ProcessExecutionStatus.Stopping]:
      ents.core.relay.processes.Execution.Status.Stopping,
    [graphql.schema.ProcessExecutionStatus.Succeeded]:
      ents.core.relay.processes.Execution.Status.Succeeded,
  }),
  graphql.transformers.IN.enumeration<
    ents.core.relay.processes.Execution.Status,
    graphql.schema.ProcessExecutionStatus
  >({
    [ents.core.relay.processes.Execution.Status.Failed]:
      graphql.schema.ProcessExecutionStatus.Failed,
    [ents.core.relay.processes.Execution.Status.InProgress]:
      graphql.schema.ProcessExecutionStatus.InProgress,
    [ents.core.relay.processes.Execution.Status.Stopping]:
      graphql.schema.ProcessExecutionStatus.Stopping,
    [ents.core.relay.processes.Execution.Status.Succeeded]:
      graphql.schema.ProcessExecutionStatus.Succeeded,
  }),
)
